import { Tag, TagColor } from '@factorialco/deprecated-design-system'

import { CardWithStatus } from './types'

export const statusTagColor = (card: CardWithStatus): TagColor => {
  if (card.approval?.status === 'rejected') {
    return Tag.Types.radical
  } else if (card.approval?.status === 'running') {
    return Tag.Types.purple
  } else if (
    card.approval?.status === 'approved' &&
    (card.status === 'requested' || card.status === 'pending')
  ) {
    return Tag.Types.lime
  } else {
    switch (card.status) {
      case 'pending':
        return Tag.Types.champagne
      case 'active':
        return Tag.Types.lime
      case 'inactive':
        return Tag.Types.radical
      case 'requested':
        return Tag.Types.purple
      case 'rejected':
        return Tag.Types.radical
      case 'canceled':
        return Tag.Types.grey
      default:
        return Tag.Types.champagne
    }
  }
}
